import React from 'react'

const AdminUsersPage = React.lazy(() => import('./Users'))
const AdminArticlesPage = React.lazy(() => import('./Articles'))
const AdminInsightsPage = React.lazy(() => import('./Insights'))

export { AdminArticlesPage, AdminInsightsPage, AdminUsersPage }
